import React from 'react'
// import TopBar from '../ProjectComponents/TopBar'
import DeleteBanner from './Components/DeleteBanner'
import IndexFooter from '../Index/Components/IndexFooter'
import DeleteBody from './Components/DeleteBody'

function DeleteAccountPage() {
  return (
    <>
        {/* topbar */}
        <div className='bg-main main'>
          {/* <TopBar/> */}
          {/* <TopBar/> */}
          <DeleteBanner/>
        </div>
            <DeleteBody/>
        <IndexFooter/>
    </>
  )
}

export default DeleteAccountPage